import { Component } from '@angular/core';
import { CreditService } from '../credit.service';
import { Credit } from '../credit';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-credit-edit',
  templateUrl: 'edit.component.html',
})
export class CreditEditComponent {
  /**
   * Details of the credit being edited.
   */
  public credit: Credit;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {CreditService} creditService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private creditService: CreditService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.creditService.loading.subscribe(result => (this.isLoading = result));
    this.route.params.subscribe(params => this.loadCredit(params.id));
  }

  /**
   * Perform the edit action which send the edited credit to the backend.
   */
  public edit() {
    const editCredit = this.creditService
      .updateCredit(this.credit.id, this.credit)
      .subscribe(
        (result: Credit) => {
          this.notificationService.success(
            `Credit Updated`,
            `The credit ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.credit = new Credit();
          editCredit.unsubscribe();
          this.router.navigate(['/credits']);
        },
        err => {
          this.notificationService.error(
            `Credit Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/credits']);
        },
      );
  }

  /**
   * Loads the requested credit so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadCredit(id: string) {
    this.creditService.findCredit(id).subscribe(
      result => {
        this.credit = result;
      },
      err => {
        this.notificationService.error(
          `Credit Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/credits']);
      },
    );
  }
}
